<app-menu>
  <div class="container">
    <img src="assets/images/builtup.svg" alt="Logo BuiltUP" />
  </div>
</app-menu>
